import { render } from "./KnowledgeBase.vue?vue&type=template&id=536c8546&scoped=true"
import script from "./KnowledgeBase.vue?vue&type=script&lang=js"
export * from "./KnowledgeBase.vue?vue&type=script&lang=js"

import "./KnowledgeBase.vue?vue&type=style&index=0&id=536c8546&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-536c8546"]])

export default __exports__